export default function PricingSection() {
  return (
    <section className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-emerald-50 rounded-full mb-6">
            <i className="ri-money-dollar-circle-line text-emerald-600 text-xl mr-3"></i>
            <span className="text-emerald-600 text-sm font-bold">PRICING</span>
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            料金・<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">販売価格</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Main Pricing Card */}
          <div className="bg-gradient-to-br from-teal-500 to-cyan-500 rounded-3xl p-12 text-white mb-12 shadow-2xl">
            <div className="text-center">
              <h3 className="text-4xl font-black mb-4">
                販売価格（表示価格）+ 変更登記費用
              </h3>
              <div className="w-24 h-1 bg-white/30 mx-auto mb-8"></div>
              <p className="text-xl leading-relaxed">
                弊社で頂くお代金は販売価格（表示価格）のみです。<br />
                手数料などは表示している販売価格に含まれております。
              </p>
            </div>
          </div>

          {/* Details Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-500">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-price-tag-3-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">販売価格</h4>
              <p className="text-gray-600 leading-relaxed">
                表示されている価格のみで、追加の手数料は一切かかりません。明朗会計で安心してご利用いただけます。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-500">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-file-edit-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">変更登記費用</h4>
              <p className="text-gray-600 leading-relaxed mb-4">
                ただし登記にかかる費用は別途必要となります。
              </p>
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border border-blue-200">
                <p className="text-gray-700 font-bold mb-2">一般的なケース</p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  役員・本店所在地などの変更
                </p>
                <p className="text-3xl font-black text-blue-600 mt-4">
                  7万円〜15万円
                </p>
              </div>
            </div>
          </div>

          {/* Note */}
          <div className="mt-12 bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-gray-200">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-gradient-to-br from-gray-400 to-gray-600 rounded-xl flex items-center justify-center mr-6 flex-shrink-0">
                <i className="ri-information-line text-2xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  こちらは実費となり、弊社で頂くものではありません。ご不明点は相談ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
